import _ from 'lodash'
import ShipmentUnit from './ShipmentUnit'

export default class ShippingDocument {
  id = 0
  date = null
  carrierCustomer = {
    label: null,
    value: null
  }
  transport = null
  senderCustomer = {
    label: null,
    value: null
  }
  receiverCustomer = {
    label: null,
    value: null
  }
  receiverAddress = null
  state = {
    label: null,
    value: null
  }

  shipments = [
    new ShipmentUnit({})
  ]

  constructor (data) {
    _.forEach(data, (value, field) => {
      if (this.hasOwnProperty(field)) {
        this[field] = value
      }
    })

    if (data.shipments) {
      this.shipments = _.map(data.shipments, shipment => new ShipmentUnit(shipment))
    }
  }
}
